import Module from '../../utils/modules/Module';
import EventsManager from '../../utils/events/EventsManager';
import CustomEvents from '../../utils/events/CustomEvents';

export default class SideNav extends Module {
  constructor(options) {
    super(options)

    this.main = document.querySelector('.page-main');
    this.content = document.querySelector('.page-content.has-nav');
    this.nav = document.querySelector('.side-nav');
    this.navLinks = document.querySelectorAll('.side-nav a');
    this.sections = document.querySelectorAll('section');
    this.mainMenuHeight =  parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height').replace('px','')) - 58;

    this.followMenu_bind = this.followMenu.bind(this);
    this.openMenu_bind = this.openMenu.bind(this);
    this.onNavClick_bind = this.onNavClick.bind(this);
    this.lastScrollTop = 0;

    this.init();
  }

  /**
   * Initial state of the side navigation
   */
  init() {
    let self = this;

    // event listeners
    window.addEventListener('scroll', this.followMenu_bind);
    document.querySelector('.side-nav-item-title').addEventListener('click', this.openMenu_bind);
    document.querySelector('.side-nav-item-title').addEventListener('keypress', this.openMenu_bind);
    this.navLinks.forEach((el) => {
        el.addEventListener('click', this.onNavClick_bind)
      });

    // border for hero full
    if (document.querySelector('.hero-full') || document.querySelector('.page-node-type-event-landing')) {
      this.main.classList.add('border');
    }

    // set height
    if (window.innerWidth <= 1200) {
      this.nav.style.height = document.querySelector('.side-nav-item-title').clientHeight + 'px';
      this.content.style.marginTop = "0";
    }
    else {
      this.content.style.marginTop = (0 - this.nav.clientHeight)+"px";
    }

    // reset height on resize
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 1200) {
        self.nav.style.height = document.querySelector('.side-nav-item-title').clientHeight + 'px';
        self.content.style.marginTop = "0";
      }
      else {
        self.nav.style.height = 'initial';
        self.content.style.marginTop = (0 - self.nav.clientHeight)+"px";
      }
      self.main.classList.remove('open');
    });
    this.openMenu();
  }



  /** ------------------------------
   * Events
   --------------------------------- */
  /**
   * Make the side nav sticky when necessary
   */
  followMenu () {
    let topWindow = window.pageYOffset;
    // downscroll
    if (topWindow > this.lastScrollTop) {
      this.nav.style.top = this.mainMenuHeight + 20 + 'px';
    }
    // upscroll
    else if (!document.querySelector('.page-node-type-event-landing')) {
      this.nav.style.top = this.mainMenuHeight + 60 + 'px';
    }

    // links state when pasted by it's anchor destination
    this.sections.forEach((el) => {
      let elementTop = el.getBoundingClientRect().top + window.scrollY - 200,
        matchingLink = null;

      if (el.id) {
        matchingLink = document.querySelector('.side-nav-link[href="#' + el.id + '"]');
      }

      if (matchingLink) {
        if (topWindow >= elementTop ) {
          matchingLink.classList.add('btn-line-active');
        } else {
          matchingLink.classList.remove('btn-line-active');
        }
      }
    });

    this.lastScrollTop = topWindow <= 0 ? 0 : topWindow;
  }



  /**
   * Open or close the side-nav
   * @param e - Summary title
   */
  openMenu (e = null) {
    let container = document.querySelector('.side-nav-list');
    if (e) {
      e.preventDefault();
    }
    this.main.classList.toggle('open');

    if (!this.main.classList.contains('open')) {
      container.setAttribute('aria-expanded', 'true')
      this.navLinks.forEach(el => {
        el.setAttribute('tabindex', '-1');
      });
      if (window.innerWidth <= 1200) { //mobile
        this.nav.style.height = document.querySelector('.side-nav-item-title').clientHeight + 'px';
      }
    }
    else {
      container.setAttribute('aria-expanded', 'false');
      this.navLinks.forEach(el => {
        el.setAttribute('tabindex', '0');
      });
      if (window.innerWidth <= 1200) { //mobile
        this.nav.style.height = container.clientHeight + 'px';
      }
    }

    if (window.innerWidth >= 1200) { //desktop
      this.content.style.marginTop = (0 - this.nav.clientHeight)+"px";
    }

    // used to refresh sliders
    EventsManager.broadcast(CustomEvents.summary.SUMMARY_OPEN);
  }



  /**
   * Carefully place the scroll to anchor
   * not to close to the top of the window
   * @param e - the link
   */
  onNavClick (e) {
    e.preventDefault();
    const $link = e.target,
      elementID = $link.getAttribute('href'),
      $target = document.querySelector(elementID),
      $targetRect = $target.getBoundingClientRect(),
      bodyRect = document.body.getBoundingClientRect(),
      targetOffSet = $targetRect.top - bodyRect.top - this.mainMenuHeight - 100;

    window.scroll({
      top: targetOffSet,
      left: 0,
      behavior: 'smooth'
    });
  }

}
